import { useState } from "react";

import { useTheme } from "../../../context/theme";
import { DISABLED_TEXT_OPACITY } from "../../../styles/colors/consts";
import { Icon } from "../../content";
import { Box } from "../../layout";
import { InputProps } from "./types";

type Props = InputProps<string> & {
  type: "text" | "email" | "password";
  id: string;
  name?: string;
  error?: boolean;
  dataTest?: string;
};

export default function TextInput(props: Props) {
  const {
    id,
    name,
    error,
    dataTest = "FormInput",
    disabled,
    ...inputProps
  } = props;

  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordType = inputProps.type === "password";
  const passwordTypeState = showPassword ? "text" : "password";
  const type = isPasswordType ? passwordTypeState : inputProps.type;

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      position="relative"
    >
      <Box
        disabled={disabled}
        component="input"
        id={id}
        name={name}
        {...inputProps}
        dataTest={dataTest}
        width="100%"
        borderRadius="small"
        borderStyle="solid"
        borderWidth="xxxsmall"
        opacity={disabled ? DISABLED_TEXT_OPACITY : "1"}
        backgroundColor={theme.foreground}
        color={theme["neutral-high-content"]}
        borderColor={
          error ? theme["error-high-content"] : theme["neutral-high-content"]
        }
        focusStyles={{
          borderColor: theme["primary-high-content"],
          outline: "0"
        }}
        placeholderStyles={{
          color: theme["neutral-medium-content"]
        }}
        paddingLeft="xlarge"
        paddingY="12"
        paddingRight={isPasswordType ? "xxxlarge" : "xlarge"}
        type={type}
      />

      {isPasswordType && (
        <Box
          top="50%"
          right="10px"
          position="absolute"
          transform="translateY(-50%)"
          cursor={disabled ? undefined : "pointer"}
          onClick={() => !disabled && setShowPassword(!showPassword)}
        >
          <Icon
            size="xlarge"
            tone="neutral"
            iconName={showPassword ? "eyeSlashed" : "eye"}
            accessibilityLabel={showPassword ? "show" : "hide"}
          />
        </Box>
      )}
    </Box>
  );
}
